var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VTabel',{attrs:{"height":_vm.height,"columns":_vm.columns,"data":_vm.dataList,"loading":_vm.loading}}),_vm._v(" "),_c('detail-model',_vm._b({attrs:{"show":_vm.detail.show},on:{"update:show":function($event){return _vm.$set(_vm.detail, "show", $event)}}},'detail-model',_vm.detail,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f70938b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/useGas/views/alarm/index.vue
// module id = null
// module chunks = 